import { FileContentType } from 'src/graphql/types/documents'

// Single source of truth mapping a browser File MIME type to the backend
// FileContentType enum. Historically each upload surface (UploadDocumentModal,
// useUploadDocument, CreateTemplateModal, the driver CDL scan) inlined its own
// copy of this map; they drift when a new type is added. New code should import
// from here.
export const FILE_CONTENT_TYPE_BY_MIME_TYPE: Record<string, FileContentType> = {
  'image/png': FileContentType.PNG,
  'image/jpeg': FileContentType.JPG,
  'image/jpg': FileContentType.JPG,
  'image/tiff': FileContentType.TIF,
  'image/gif': FileContentType.GIF,
  'image/heic': FileContentType.HEIC,
  'image/heif': FileContentType.HEIC,
  'application/pdf': FileContentType.PDF,
  'text/html': FileContentType.HTML,
  'application/msword': FileContentType.DOC,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    FileContentType.DOC,
  'application/zip': FileContentType.ZIP,
  'text/csv': FileContentType.CSV,
  'text/plain': FileContentType.TXT,
  'audio/wav': FileContentType.WAV,
  'audio/x-wav': FileContentType.WAV,
  'video/mp4': FileContentType.MP4,
  'application/vnd.ms-excel': FileContentType.XLS,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    FileContentType.XLS,
}

// Resolves a File MIME type to its FileContentType, defaulting to UNKNOWN so an
// unrecognized type still stores (and the backend/AI can reject it).
export const fileContentTypeFromMimeType = (
  mimeType: string
): FileContentType =>
  FILE_CONTENT_TYPE_BY_MIME_TYPE[mimeType] ?? FileContentType.UNKNOWN
